if (!customElements.get('shoev-filtration-story')) {
  customElements.define('shoev-filtration-story', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._controls = Array.from(this.querySelectorAll('[data-filter-control]'));
      this._details = Array.from(this.querySelectorAll('[data-filter-detail]'));
      this._media = Array.from(this.querySelectorAll('[data-filter-media]'));
      this._onActivate = this.activate.bind(this);
      this._onKeydown = this.onKeydown.bind(this);
      this._finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

      this._controls.forEach((control) => {
        control.addEventListener('click', this._onActivate);
        control.addEventListener('focus', this._onActivate);
        control.addEventListener('keydown', this._onKeydown);
        control.addEventListener('pointerenter', this._onActivate);
      });

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-visible', entry.isIntersecting));
        }, { threshold: 0.2 });
        this._observer.observe(this);
      } else {
        this.classList.add('is-visible');
      }
    }

    disconnectedCallback() {
      this._controls.forEach((control) => {
        control.removeEventListener('click', this._onActivate);
        control.removeEventListener('focus', this._onActivate);
        control.removeEventListener('keydown', this._onKeydown);
        control.removeEventListener('pointerenter', this._onActivate);
      });
      if (this._observer) this._observer.disconnect();
      this._initialized = false;
    }

    activate(event) {
      if (event.type === 'pointerenter' && !this._finePointer.matches) return;
      const index = event.currentTarget.dataset.filterControl;
      this._controls.forEach((control) => {
        const active = control.dataset.filterControl === index;
        control.setAttribute('aria-selected', String(active));
        control.tabIndex = active ? 0 : -1;
      });
      this._details.forEach((detail) => {
        const active = detail.dataset.filterDetail === index;
        detail.classList.toggle('is-active', active);
        detail.setAttribute('aria-hidden', String(!active));
        detail.toggleAttribute('inert', !active);
      });
      this._media.forEach((media) => {
        const active = media.dataset.filterMedia === index;
        media.classList.toggle('is-active', active);
        media.setAttribute('aria-hidden', String(!active));
      });
      this.style.setProperty('--active-stage', index);
    }

    onKeydown(event) {
      const currentIndex = this._controls.indexOf(event.currentTarget);
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this._controls.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this._controls.length) % this._controls.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this._controls.length - 1;
      if (nextIndex === null) return;

      event.preventDefault();
      const nextControl = this._controls[nextIndex];
      nextControl.focus({ preventScroll: true });
      this.activate({ currentTarget: nextControl, type: 'keyboard' });
      nextControl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
}
